export default __webpack_public_path__ + "static/media/round_trip.8b98d02d.svg";